// Função para remover pontuação do CNPJ
export function unformatCNPJ(cnpj) {
    return cnpj.replace(/[^\d]/g, ''); // Remove todos os caracteres que não são dígitos
}

// Função para formatar CNPJ (000000000000000 -> 00.000.000/0000-00)
export function formatCNPJ(cnpj) {
    if (!cnpj) {
        return '';
    }
    cnpj = cnpj.toString();
    if (cnpj.length === 14) {
        return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    }
    return cnpj;
}

// Valida CNPJ
export function isValidCNPJ(cnpj) {
    
    cnpj = cnpj.replace(/[^\d]+/g, ''); // Remove caracteres não numéricos
    
    if (cnpj.length !== 14) return false;

    // Elimina CNPJs com todos os dígitos iguais
    if (/^(\d)\1+$/.test(cnpj)) return false;

    let tamanho = cnpj.length - 2;
    let numeros = cnpj.substring(0, tamanho);
    let digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;

    for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) pos = 9;
    }

    let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado !== parseInt(digitos.charAt(0))) return false;

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;

    for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) pos = 9;
    }

    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    return resultado === parseInt(digitos.charAt(1));
}

